import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field, FormSection } from "redux-form";

import { CheckButton, CustomInput } from "components";
import { float2Normalizer } from "validators";
import {
	floatValidation,
	onlyPercent,
	validateHowDoYouAcceptCards,
} from "validators/validation";

import styles from "./businessInfo.module.scss";

const AcceptCardsSection = ({ hiddenFieldsOnMPA }) => (
	<>
		<div className={`${styles.subHeader} mb-3`}>
			How Do You Accept Cards? (values must add up to 100%)
		</div>
		<Row>
			<Col lg={5}>
				<Field
					component={CustomInput}
					normalizeOnBlur={float2Normalizer}
					normalize={onlyPercent}
					label="Swiped, %"
					validate={[validateHowDoYouAcceptCards, floatValidation]}
					name="swiped"
					placeholder="0.00"
				/>
			</Col>
			<Col lg={{ span: 5, offset: 2 }}>
				<Field
					component={CustomInput}
					label="Keyed, %"
					normalizeOnBlur={float2Normalizer}
					normalize={onlyPercent}
					validate={[validateHowDoYouAcceptCards, floatValidation]}
					name="keyed"
					placeholder="0.00"
				/>
			</Col>
		</Row>
		<Row>
			<Col lg={5}>
				<Field
					component={CustomInput}
					normalizeOnBlur={float2Normalizer}
					normalize={onlyPercent}
					validate={[validateHowDoYouAcceptCards, floatValidation]}
					label="eCommerce, %"
					name="eCommerce"
					placeholder="0.00"
				/>
			</Col>
		</Row>
		{!hiddenFieldsOnMPA?.includes("typesNotToAccept") && (
			<Row>
				<Col>
					<div className={`${styles.subHeader} mb-3`}>
						Types not to accept
					</div>
					<FormSection name="excludeCardTypes">
						<div className={styles.inlineItems}>
							<Field
								component={CheckButton}
								label="Visa"
								name="visa"
								id="visaExcludeCardTypes"
								hideRequiredMark
								wrapperClassName={styles.item}
							/>
							<Field
								component={CheckButton}
								label="Mastercard"
								name="master_card"
								id="masterCardExcludeCardTypes"
								hideRequiredMark
								wrapperClassName={styles.item}
							/>
							<Field
								component={CheckButton}
								label="Discover"
								name="discover"
								id="discoverExcludeCardTypes"
								hideRequiredMark
								wrapperClassName={styles.item}
							/>
							<Field
								component={CheckButton}
								label="AMEX"
								name="amex"
								id="amexExcludeCardTypes"
								hideRequiredMark
								wrapperClassName={styles.item}
							/>
							<Field
								component={CheckButton}
								label="PayPal"
								name="pay_pal"
								id="pay_palExcludeCardTypes"
								hideRequiredMark
								wrapperClassName={styles.item}
							/>
						</div>
					</FormSection>
				</Col>
			</Row>
		)}
	</>
);

export default memo(AcceptCardsSection);
